import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation, OnChanges } from '@angular/core';
import { PrintBatchData } from '@app/services/batches/print-batches';
import { FreightServiceType } from '@pdqdev/pdq-shared/dist/CarrierData';
import { BatchAction, BatchActionsService } from '../../services/batch-actions.service';

@Component({
  selector: 'app-recently-printed-item',
  templateUrl: './recently-printed-item.component.html',
  styleUrls: ['./recently-printed-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class RecentlyPrintedItemComponent implements OnInit, OnChanges {
  @Input() batch: PrintBatchData;
  @Input() batchStatus: 'running' | 'printing' | 'recentlyDone';
  @Input() disableBackToAssign: boolean;
  batchActions: ReadonlyArray<BatchAction>;
  isTplCarrier: boolean = false;
  batchFailures: string;

  constructor(public batchActionsService: BatchActionsService) {}

  ngOnInit(): void {
    this.batchActions = this.batchActionsService.getBatchActionsByStatus(this.batchStatus);

    this.isTplCarrier = this.batch.selectedCarrier?.freightServiceType?.includes(
      FreightServiceType.FULFILLMENT_SERVICE_3PL,
    );
  }

  displayBatchFailedText(failedNum) {
    switch (failedNum) {
      case 0:
        return 'No labels generated';
      case 1:
        return failedNum + " label generation failed. it's now back in the Assign screen";
      default:
        return failedNum + " label generations failed. They're back in the Assign screen";
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.batch) {
      const listFailures = this.batch.failures.split(',');

      if (listFailures[listFailures.length - 1] === '') {
        listFailures.splice(listFailures.length - 1, 1);
      }

      this.batchFailures = listFailures.reduce((result: string, item: string, index: number) => {
        if (index < 20) {
          result += `${result === '' ? '' : ', '} ${item}`;
        }

        return result;
      }, '');

      this.batchFailures += listFailures.length > 19 ? ', ...' : '';
    }
  }
}
